import React, { useEffect } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import {
  Card,
  Badge
} from '@lockerpm/design';

import itemsComponents from "../../../../components/items";

const Information = (props) => {
  const { DocLink } = itemsComponents;
  const { t } = useTranslation();
  const { isPremium } = props;

  const userInfo = useSelector((state) => state.auth.userInfo);

  useEffect(() => {
  }, [])
  return (
    <Card bodyStyle={{ padding: 16 }}>
      <p className="font-semibold">
        {t('private_email.your_root_email')}: <span className="font-bold">{userInfo.email}</span>
      </p>
      <div className="my-4">
        <p className="mb-1"><Badge status="default" className="mr-2"/>
          {t('private_email.description1')}
        </p>
        <p className="mb-1"><Badge status="default" className="mr-2"/>
          {t(`private_email.${isPremium ? 'description2' : 'free_description2'}`)}
        </p>
        <p className="mb-1"><Badge status="default" className="mr-2"/>
          {t(`private_email.${isPremium ? 'description3' : 'free_description3'}`)}
        </p>
        <p><Badge status="default" className="mr-2"/>
          {t(`private_email.${isPremium ? 'description4' : 'free_description4'}`)}
        </p>
      </div>
      <DocLink
        className="font-semibold"
        title={t('private_email.doc')}
        docKey="PRIVATE_EMAIL_URL"
      />
    </Card>
  );
}

export default Information;